export default "__VITE_ASSET__91e46a47__"